<NMessageProvider><div class="simple-layout"><RouterView></RouterView></div></NMessageProvider>